// extracted by mini-css-extract-plugin
module.exports = {"md":"Settings_md_2xBuP","ios":"Settings_ios_3jjvy"};